module.exports = "<app-subsidiary-memorandum-list></app-subsidiary-memorandum-list>"